export default {
  data() {
    return {
      RETAIN_KEY: ['localeLanguage', 'versionData'] // 需要保留的键名数组
    }
  },
  methods: {
    /**
     * 全局清除方法，可保留全局需要保留的字段，其他全部清除
     * @param type 不传type清全部；传localStorage或sessionStorage就只清除对应缓存
     */
    clearGlobalStorage(type) {
      // 定义清除存储的函数
      const clearStorage = (storage) => {
        // 获取存储的所有键名
        for (let i = storage.length - 1; i >= 0; i--) { //向前遍历，解决删除后长度变化的问题
          let key = storage.key(i);
          // 如果这个键名不在保留的键名数组中，就移除它
          if (this.RETAIN_KEY.indexOf(key) < 0) {
            storage.removeItem(key);
          }
        }
      };

      // 根据传入的type参数决定清除哪个存储
      if (type === 'localStorage' || type === 'sessionStorage') {
        clearStorage(window[type]);
      } else {
        // 如果没有传type或者传的type不是localStorage或sessionStorage，则清除全部
        clearStorage(localStorage);
        clearStorage(sessionStorage);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/storageClear.js